import React, {useState } from "react"
import AInput from "views/pages/manage/common/formFeilds/customInput/AInput"
import { customStyle, inputAmountStyle, labelSyle, numberDecimalLimitRegex, 
    // validatePaymentMode
 } from "../../components/constant"
import CustomDatePickerV2 from "views/pages/manage/common/commonComponents/CustomDatePicker-V2"
import moment from "moment"
import { Col,Row } from "reactstrap"
import Error from "../../errorHandlimg/Error"
import JodoHistoryPopup from "../JodoHistoryPopup"
import {  jodoValidation } from "../../validations/paymentModeValidation"
import { getConditionalCOllectSaveButton } from "../../components/common"
const JODOView = ({ isEditForm,isReceiptEdit=false, isView=false,contextValue,rowId,handleClose}) => {
    const [isOpen, setIsOpen] = useState(false)
    
    const [errorMgs, setErrorMgs] = useState()

    const {
        paymentModeFormHandler,
        studentBasicDetails, 
        currentPaymentMode,
        paymentModeForm,
        selectedChargesAmount,
        bankMasterId,
        setBalanceAmount,
        setBalanceMode,
        setloader,
        setCollectPayment,
        collectPayment,
        balanceAmount,
        setModifyPaymentModeData,
        validatePaymentMode,
        disableAmountField
    } = contextValue;
    const validatePayment=async()=>{
        const error=await jodoValidation(paymentModeForm,collectPayment,balanceAmount)
        setErrorMgs(error)
        if(!error)
            {
               const isOk= await validatePaymentMode(studentBasicDetails, currentPaymentMode, paymentModeForm, selectedChargesAmount, bankMasterId, '', setBalanceAmount, setBalanceMode, setloader, setCollectPayment, balanceAmount, collectPayment);
               if(isOk){
                isReceiptEdit===true &&setModifyPaymentModeData((prev) => ({ ...prev, [rowId]: paymentModeForm }))
                isReceiptEdit&&handleClose(true)
               }
    
            } 
}
const disabled= !(paymentModeForm?.referenceNumber && paymentModeForm?.paidAmount && paymentModeForm?.paymentModeDate)

    return (
        <>
            {!isView&&!isReceiptEdit&&<div className=" d-flex justify-content-between align-items-center mt-2">
                <span className="large-bold color-dark">JODO</span>
                <div className="d-flex justify-content-between align-items-center" onClick={()=>{setIsOpen(true)}}><span className="large-semi-bold color-primary mr-1 cursor" style={{textDecoration:'underline'}}>Check history</span> </div>
            </div>
            }
            <Row>
                <Col md="4">
                    <div>
                        <AInput
                            label="Flex ID*"
                            labelStyle={labelSyle}
                            value={paymentModeForm?.referenceNumber}
                            handler={(value) => {paymentModeFormHandler("referenceNumber",value) }}
                            placeholder="Enter"
                            style={{ height: "47px", width: '265px', borderRadius: "5px" }}
                            disabled={isView}
                        />
                    </div>
                </Col>
                <Col md="4">
                    <div>
                        <AInput
                            label="Debited Amount*"
                            labelStyle={labelSyle}
                            value={paymentModeForm?.paidAmount}
                            handler={(value) => {
                                if (
                                    !value || parseFloat(value) > 0
                                ) {
                                    paymentModeFormHandler('paidAmount', value)
                                }
        
                            }}
                            customIcon={
                                <div className='large-semi-bold'>&#8377;</div>
                              }
                              customIconStyle={customStyle}
                            placeholder="Enter"
                            style={inputAmountStyle}
                            disabled={isView || isReceiptEdit===true || disableAmountField}
                            regex={numberDecimalLimitRegex(10, 2)}
                        />
                    </div>
                </Col>
                <Col md="4">
                    <div style={{ width: '265px' }}>
                        <CustomDatePickerV2
                            label="Transaction Date*"
                            labelStyle={labelSyle}
                            style={{ input: { minHeight: "47px" } }}
                            placeHolder="Select date"
                            value={paymentModeForm?.paymentModeDate}
                            handler={(index, date) => {paymentModeFormHandler("paymentModeDate",date )}}
                            isStartDate={true}
                            //minDate={moment(new Date(), "DD-MM-YYYY").subtract(1, "months")}
                            maxDate={new moment(new Date())}
                            disabled={isView}
                        />
                    </div>
                </Col>
            </Row>
            {getConditionalCOllectSaveButton(disabled,
                paymentModeForm,
                validatePayment,
                isReceiptEdit,
                isEditForm,
                isView,
                setModifyPaymentModeData,
                rowId,
                handleClose)}
            <Error errorMgs={errorMgs}/>
            <JodoHistoryPopup isOpen={isOpen} setOpen={setIsOpen} psId={studentBasicDetails?.psid}/>

        </>
    )
}
export default JODOView